import { Permission } from '../api_services/types';

export const BACKOFFICE_PILOT_MISSIONS_MODERATE = 'BACKOFFICE_PILOT_MISSIONS_MODERATE';

export const PERMISSIONS_TO_VIEW_MISSIONS: Permission[] = [
  'BACKOFFICE_API_GCP_REQUEST_GET',
  'BACKOFFICE_PILOT_DOCUMENTS_ACCESS',
  'BACKOFFICE_PILOT_INFO_VIEW',
  'BACKOFFICE_PILOT_INVOICES_ACCESS',
  // Requested so the pilot's JWT carries MANAGE_OWN once login-service grants it and the
  // consultant-invoices-api status endpoint switches from *_ACCESS to MANAGE_OWN (invoice cancel).
  'BACKOFFICE_PILOT_INVOICES_MANAGE_OWN',
  'BACKOFFICE_UPLOAD_GCP_FILES',
  BACKOFFICE_PILOT_MISSIONS_MODERATE,
  'BACKOFFICE_PILOT_UPLOAD_PANO',
  'BACKOFFICE_PILOT_UPLOAD_SCAN',
  'CUSTOMER_VIEW',
  'SITE_VIEW',
];
